<template>
  <v-layout>
    <v-flex class="my-4" xs5 v-html="settingName" v-if="displayLabel"/>
    <v-flex xs6>
      <v-select
        :items="arrayEmailTemplates"
        item-text="templateKey"
        item-value="templateKey"
        v-model="templateName"
        @input="changeTemplateKey"
        label="Choose Email Template"
        autocomplete
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'email-select',
    props: {
      displayLabel: {
        type: Boolean,
        required: false,
        default: true
      },
      settingName: {
        type: String,
        required: true
      },
      arrayEmailTemplates: {
        type: Array,
        default: () => ([]),
        required: true
      },
      action: {
        type: String,
        required: true
      },
      value: {
        type: String,
        default: ''
      }
    },
    date () {
      return {
        templateName: ''
      }
    },
    watch: {
      value: {
        handler (val) {
          this.templateName = val
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions([
        'fetchGeneralSettings',
        'updateAttendeeConfirmationTemplate',
        'updateAttendeeMessageTemplate',
        'updateBlitzSubmittedTemplate',
        'updateContactUsTemplate',
        'updateEnableVideoRequestTemplate',
        'updateInvoiceRefundSendingTemplate',
        'updateInvoiceSendingTemplate',
        'updateListingSubmittedTemplate',
        'updateResetPasswordTemplate',
        'updateIPNSendingTemplate',
        'updateIPNRefundSendingTemplate',
        'updateAttendeeToAgendaAdminMessageTemplate',
        'updateAttendeeToParticipantMessageTemplate',
        'updateAttendeeToSpeakerMessageTemplate'
      ]),
      async changeTemplateKey (val) {
        try {
          await this[this.action]({ templateName: val })
          await this.fetchGeneralSettings()
        } catch (err) {
          console.error(err)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/EmailNotificationsSettings/EmailTemplatesSettings/emailSelect.vue